/**
 * HLOS-28 — Constantes do vault (espelham `hlos/vault/crypto.py` + `mnemonic.py`).
 *
 * KEEP IN SYNC com Python — qualquer divergência quebra paridade byte-a-byte.
 */

/// ─────────────────────────────────────────────────────────────────────────────
// Domain separation (HKDF info / Argon2id salt concat)
// ─────────────────────────────────────────────────────────────────────────────

/** Domain separation: passphrase → KEK. */
export const PASSPHRASE_INFO = new TextEncoder().encode("vault-passphrase-v1");

/** Domain separation: mnemonic → KEK. */
export const MNEMONIC_INFO = new TextEncoder().encode("vault-mnemonic-v1");

/** Domain separation: KEK → AES-GCM wrap key. */
export const WRAP_INFO = new TextEncoder().encode("vault-key-wrap-v1");

// ─────────────────────────────────────────────────────────────────────────────
// Argon2id (espelham `crypto.py`)
// ─────────────────────────────────────────────────────────────────────────────

export const ARGON2_TIME_COST = 3;
export const ARGON2_MEMORY_COST_KIB = 64 * 1024; // 64 MiB
export const ARGON2_PARALLELISM = 4;
export const ARGON2_OUTPUT_LENGTH = 32; // 256-bit KEK
export const ARGON2_SALT_LENGTH = 16;
export const ARGON2_VERSION = 0x13;

// ─────────────────────────────────────────────────────────────────────────────
// BIP-39
// ─────────────────────────────────────────────────────────────────────────────

export const BIP39_STRENGTH_BITS = 256; // 24 palavras (espelha `vault.MNEMONIC_STRENGTH_BITS`)
export const VALID_STRENGTHS = [128, 160, 192, 224, 256] as const;
export const SEED_BYTES = 64; // 512-bit BIP-39 seed

// ─────────────────────────────────────────────────────────────────────────────
// Vault serialization
// ─────────────────────────────────────────────────────────────────────────────

export const VAULT_VERSION = 1; // espelha `vault.VAULT_VERSION`

/** Tamanho mínimo razoável para passphrase (CL-08: zero trivial). */
export const MIN_PASSPHRASE_LENGTH = 1;

/** Tamanho do DEK (256-bit). */
export const DEK_BYTES = 32;

/** Tamanho do salt (NIST SP 800-132). */
export const SALT_BYTES = 16;

// ─────────────────────────────────────────────────────────────────────────────
// Auto-lock (segurança)
// ─────────────────────────────────────────────────────────────────────────────

/** Timeout padrão do auto-lock: 5 minutos (espelha comportamento UX). */
export const DEFAULT_AUTO_LOCK_MS = 5 * 60 * 1000;
